import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { RecordsService } from '@services/records/records.service';

@Component({
  selector: 'app-opendialog-delete-all-records',
  templateUrl: './opendialog-delete-all-records.component.html',
  styleUrls: ['./opendialog-delete-all-records.component.scss']
})
export class OpendialogDeleteAllRecordsComponent implements OnInit {
  confirm = false;

  constructor(
    public dialogRef: MatDialogRef<OpendialogDeleteAllRecordsComponent>,
    private router: Router,
    private recordService: RecordsService
  ) { }

  ngOnInit(): void {
  }

  confirmAction(): void {

    this.recordService.resetAllRecords().subscribe({
      next: () => {
        this.confirm = true;
        this.router.navigate(['/dashboard']);

        setTimeout(() => {
          this.confirm = false;
          this.dialogRef.close();
        }, 2500);
      }
    });


  }

}
